import { Box, Card, CardActionArea, CardContent, IconButton, Typography } from "@mui/material"
import { useState } from "react"

export type LandingCardProps = {
    icon: React.ReactElement,
    title: string,
    description: string
    link?: any
}

export function LandingCard({ icon, title, description, link }: LandingCardProps) {
    const [hover, setHover] = useState(false);
    return (
        <a href={link} style={{ textDecoration: 'none' }}>
            <Box position="relative" height="100%" width='100%'>
                <Card sx={{ border: 0, borderRadius: 5, }}
                    onMouseOver={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    raised={hover}
                >
                    <CardActionArea>
                        <CardContent sx={{ padding: 0 }}>
                            <Typography align='center' paddingTop={4} fontWeight='bold'>
                                {title}
                            </Typography>
                            <Box
                                height={hover ? 'fit-content' : '140px'}
                                minHeight='140px'
                                maxWidth='100%'
                                minWidth='100%'
                                sx={{
                                    typography: 'body2',
                                    padding: 2,
                                    overflow: 'hidden',
                                    textAlign: 'left',
                                    textOverflow: 'ellipsis',
                                    '&:after': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        width: '100%',
                                        height: hover ? '0%' : '25%',
                                        bottom: 0,
                                        zIndex: 1,
                                        background: 'linear-gradient(to top, #fff, rgba(0,0,0,0))',
                                    },
                                }}>
                                {description}
                            </Box>
                        </CardContent>
                    </CardActionArea>
                    <IconButton
                        sx={{
                            backgroundColor: "white",
                            width: 50,
                            height: 50,
                            boxShadow: "0px 0px 6px 0px #00000029",
                            position: "absolute",
                            marginLeft: "auto",
                            marginRight: "auto",
                            left: 0,
                            right: 0,
                            top: -25,
                            "&:hover": { backgroundColor: "white" },
                        }}>
                        {icon}
                    </IconButton>
                </Card>
            </Box>
        </a>
    );
}
export default LandingCard;